import { Divider, styled } from "@mui/material";

const BlueDivider = styled(Divider)(({ theme }) => {
    return {
        borderWidth: 1,
        backgroundColor: theme.palette.primary.light,
        width: "100%",
        minWidth: "50px",
        maxWidth: "75px",
    };
});

export default BlueDivider;
